/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespIconBubbles_viewer = {|
  +isPinterestShareEnabled: ?boolean;
  +isFacebookShareEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isPinterestShareEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "PINTEREST_SHARE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"PINTEREST_SHARE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isFacebookShareEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FACEBOOK_SHARE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"FACEBOOK_SHARE\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
